import { Text } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { Dropdown } from '../Dropdown';
import { DropdownStatusIcon } from '../utils';
import { AAMVACaption } from './AAMVACaption';
import { AAMVADetailsTable } from './AAMVADetailsTable';
import { useGlobalState } from 'store/reducers/reducer';
import { retrieveAamvaDetailed } from 'store/sagas/sagas';
export const AAMVACompletedResult = ({ aamvaJobResult, country, jobSid, jobStatus }) => {
    const { asyncDispatch } = useGlobalState();
    const [aamvaDetails, setAamvaDetails] = useState(null);
    const { status, statusMessage, hasErrors } = aamvaJobResult;
    useEffect(() => {
        asyncDispatch(retrieveAamvaDetailed(jobSid))
            .then((details) => {
            setAamvaDetails(details);
        })
            .catch(console.error);
    }, [asyncDispatch, jobSid]);
    return (React.createElement(Dropdown, { statusIcon: 
        // eslint-disable-next-line unicorn/prefer-includes-over-repeated-comparisons
        status === null ||
            status === 'Pending' ||
            status === 'In Progress' ? undefined : (React.createElement(DropdownStatusIcon, { dropdownHasRejections: status === 'Completed' && hasErrors, dropdownHasWarnings: false, parentJobStatus: jobStatus })), title: "DLV" },
        React.createElement(AAMVACaption, null),
        React.createElement(Text, { style: { marginBottom: 'spacing.default' } }, `Status: ${status}`),
        React.createElement(Text, null, `Status Message: ${statusMessage}`),
        React.createElement(AAMVADetailsTable, { aamvaDetails: aamvaDetails, aamvaJobResult: aamvaJobResult, country: country })));
};
